import {Checkbox} from "@mui/material";
import {formCheckboxMargin} from "@/constants";
import UpdateForm from "./UpdateForm";
import {useRestrictedDisabled} from "./tools";
import {UpdateUserProfileData} from "@/api";

type NumberField = keyof Pick<
    UpdateUserProfileData,
    | "stickyProfile"
    | "locked"
    | "callingNumberPresentationRestriction"
    | "connectedNumberPresentationRestriction"
    | "anonymousCallRejection"
    | "doNotDisturb"
    | "rejectDivertedCalls"
>;

type CheckboxInputProps = {
    form: UpdateForm;
    field: NumberField;
    disabled: boolean;
};

export const CheckboxInput = (props: CheckboxInputProps) => {
    const {field, form, disabled} = props;
    return (
        <Checkbox
            disabled={useRestrictedDisabled(field, disabled)}
            checked={form.values.profile[field]}
            onChange={(event) => form.updateProfileValues({[field]: event.target.checked})}
            color="primary"
            style={{marginLeft: formCheckboxMargin}}
        />
    );
};
